import React from 'react'
import PropTypes from 'prop-types'
import { Provider, inject, observer } from 'mobx-react'
import { toJS } from 'mobx'
import Store from './stores/Store.js'
import AddOnCategory from './components/AddOnCategory'
import AddOn from './components/AddOn'

function formattedPriceFor(addOn) {
  switch(addOn.attributes.priceMethod) {
    case "flat_rate":
      return addOn.attributes.priceFormatted
    case "hourly":
      return `${addOn.attributes.hourlyPriceFormatted}/hr`
    case "daily":
      return `${addOn.attributes.dailyPriceFormatted}/day`
    default:
      return addOn.attributes.priceFormatted
  }
}


@inject("widgetStore")
@observer
export default class AddOnGallery extends React.Component {
  static propTypes = {
    widgetStore: PropTypes.object.isRequired,
    showBookNowButton: PropTypes.bool,
    bookNowButtonText: PropTypes.string,
    showPrice: PropTypes.bool,
    buttonBackgroundColor: PropTypes.string,
    buttonForegroundColor: PropTypes.string,
    textColor: PropTypes.string,
    addOnCategoryIds: PropTypes.array,
    bookNowPackageId: PropTypes.number
  }

  static defaultProps = {
    showBookNowButton: true,
    bookNowButtonText: "Book Now",
    showPrice: true,
  }

  addOnStore = new Store({ widgetStore: this.props.widgetStore, selectedCategoryIds: this.props.addOnCategoryIds})

  componentDidMount() {
    this.addOnStore.setup()
  }

  render() {
    const { addOnStore } = this
    const { showBookNowButton, bookNowButtonText, showPrice,
      buttonBackgroundColor, buttonForegroundColor, textColor, bookNowPackageId } = this.props
    const { ready, loading, addOnCategories, addOns } = addOnStore

    if(!ready) {
      return null
    }
    else if(loading) {
      return (
        <div>Loading...</div>
      )
    }
    else {
      return (
        <Provider store={addOnStore}>
          <div style={styles.wrapper}>
            { addOnCategories.map(addOnCategory =>
              <AddOnCategory
                key={addOnCategory.id}
                addOnCategory={addOnCategory}
                textColor={textColor}
              >
                <div style={styles.addOnContainer}>
                  { addOnStore.addOnsForCategory(addOnCategory).map(addOn =>
                    <AddOn
                      key={addOn.id}
                      addOn={addOn}
                      style={styles.addOn}
                      showPrice={showPrice}
                      showBookNowButton={showBookNowButton}
                      bookNowButtonText={bookNowButtonText}
                      textColor={textColor}
                      buttonBackgroundColor={buttonBackgroundColor}
                      buttonForegroundColor={buttonForegroundColor}
                      formattedPrice={formattedPriceFor(addOn)}
                      bookNowPackageId={bookNowPackageId}
                    />
                  )}
                </div>
              </AddOnCategory>
            )}
          </div>
        </Provider>
      )
    }
  }
}

const styles = {
  wrapper: {
    maxWidth: "100%"
  },
  addOnContainer: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    alignItems: "center"
  },
  addOn: {
    width: 300
  }
}
